var isSizeFullSearchMode = false;
var sizeFullMap = {};

// Select2を安全に再初期化
function reinitSelect2($el, options) {
  if ($el.data('select2')) {
    $el.select2('destroy');
  }
  $el.siblings('.select2-container').remove();
  if (options && options.dropdownParent) {
    options.dropdownParent.children('.select2-container--open').remove();
  }
  $el.select2(options);
}
window.reinitSelect2 = reinitSelect2;

// モーダル初期化
window.initSelectItemModal = function() {
  // モーダル表示前に員数Select2を初期化＋カテゴリ初期値で品名を取得
  $('#select-item-modal').on('show.bs.modal', function() {
    initPipeNumSelect2();
    var $categorySelect = $('.category-select');
    var $itemNameSelect = $('.item-name-text-select');
    var steelPipeType = $categorySelect.val();
    if (steelPipeType && $itemNameSelect.find('option').length <= 1 && !$itemNameSelect.val()) {
      $categorySelect.trigger('change');
    }
  })

  // モーダルを閉じた時にフォームを初期化
  $('#select-item-modal').on('hidden.bs.modal', function() {
    itemSearchFealdClear();
    changeSearchStockButtonDisabled();
    // 編集モードをクリア
    if (window.clearEditingDetailRow) { window.clearEditingDetailRow(); }
    // 編集ボタンを再有効化
    $('.edit-quotation-detail').prop('disabled', false);
  })

  $('#with_milsheet').on('change',function(e){
    $(e.target).attr('checked', $(e.target).prop('checked'))
  })

  // クリアボタン
  $('.search-item-form-clear').on('click', function(e){
    e.preventDefault()
    if (window.get_maintenance_status()){
      window.location.href = window.MaintenancePath;
      return;
    }

    itemSearchFealdClear()
    changeSearchStockButtonDisabled()
    window.removeErrorMessage($('.length-text'))
  })

  // 戻り時にミルシート要をデフォルト未チェックに戻す（選択側のみ）
  $('#with_milsheet').prop('checked', false)

  // 長さ入力時のバリデーション
  $('.length-text').on('keyup change', function(e){
    window.validateNumericLengthForm($(e.target), 6)
    changeSearchStockButtonDisabled()
    window.setMaintenanceToolTip()
  })

  // 長さ変更時
  $('.length-select').on('change', function(e){
    changeSearchStockButtonDisabled()
    window.setMaintenanceToolTip()
  })

  // 寸法変更時
  $('.size-full-select').on('change', function(e){
    changeSearchStockButtonDisabled()
    window.setMaintenanceToolTip()
  })

  // 員数変更時
  $('#pipe_num').on('change', function(e){
    changeSearchStockButtonDisabled()
    window.setMaintenanceToolTip()
  })

  // 商品決定ボタン
  $('.add-quotation-detail').on('click', function(e){
    e.preventDefault()
    if (window.get_maintenance_status()){
      window.location.href = window.MaintenancePath;
      return;
    }

    triggerAddQuotationDetail()
  })

  // 商品選択モーダル内の商品決定ボタン
  $('.confirm-item-btn').on('click', function(e){
    e.preventDefault()
    if (window.get_maintenance_status()){
      window.location.href = window.MaintenancePath;
      return;
    }

    triggerAddQuotationDetail()
    $('#select-item-modal').modal('hide')
  })

  // 商品選択ボタン
  $('.open-modal').on('click', function(){
    if (window.get_maintenance_status()){
      window.location.href = window.MaintenancePath;
    }
  })

  // 長さテキストの追加バリデーション
  $('.length-text').on('keyup change', function(e){
    changeSearchStockButtonDisabled()
  })
}

// Select2 初期化 + カテゴリ選択で品名の選択肢を取得するイベント登録
window.initSelect2ForSelectItem = function() {
  var modalSelects = ['.size-full-select', '.size-full2-select', '.length-select'];
  modalSelects.forEach(function(selector) {
    var $el = $(selector);
    if ($el.data('select2')) {
      $el.select2('destroy');
    }
    $el.siblings('.select2-container').remove();
  });

  $('#select-item-modal .select2-container').each(function() {
    var $container = $(this);
    $container.remove();
  });

  $('.size-full-select').html([])
  $('.size-full2-select').html([])
  $('.length-select').html([])

  $('.size-full-select').select2({dropdownParent: $('#select-item-modal')}).parent().find('.select2-container').width('100%')
  $('.size-full2-select').select2({dropdownParent: $('#select-item-modal')}).parent().find('.select2-container').width('100%')
  $('.length-select').select2({dropdownParent: $('#select-item-modal')}).parent().find('.select2-container').width('100%')

  initPipeNumSelect2();
}

// 員数Select2の初期化
function initPipeNumSelect2() {
  if ($('.pipe-num-select').data('select2')) {
    $('.pipe-num-select').select2('destroy');
  }
  $('.pipe-num-select').siblings('.select2-container').remove();
  $('.pipe-num-select').select2({
    tags: true,
    dropdownParent: $('#select-item-modal'),
    createTag: function(params) {
      var term = $.trim(params.term);
      if (term === '' || !/^\d+$/.test(term)) return null;
      var num = parseInt(term, 10);
      if (num < 1 || num > 9999) return null;
      var normalized = num.toString();
      return { id: normalized, text: normalized };
    },
    matcher: function(params, data) {
      if ($.trim(params.term) === '') return data;
      if (data.text.indexOf($.trim(params.term)) === 0) return data;
      return null;
    }
  }).parent().find('.select2-container').width('100%');
}

//カテゴリ選択時に品名・規格名の選択肢を取得
$(document).on('change', '.category-select', function() {
  var steelPipeType = $(this).val();
  var $itemNameSelect = $('.item-name-text-select');
  if ($itemNameSelect.data('select2')) {
    $itemNameSelect.select2('destroy');
  }
  $itemNameSelect.html('<option value="">選択してください</option>');
  // 寸法以降をクリア
  $('.size-full-select').html([]);
  $('.size-full2-select').html([]);
  $('.length-select').html([]);
  $('.length-text').val(null);
  $('.enter_length_text').html(null);
  window.removeErrorMessage($('.length-text'));
  $('.select-pipe-num').val('1').trigger('change');
  // 「寸法から選択」の選択状態を解除した場合、フォーム順序を元に戻す
  isSizeFullSearchMode = false;
  swapToItemNameFirst();
  $('.size-full-select').off('change.filter-item-name');

  changeSearchStockButtonDisabled();

  if (!steelPipeType) return;

  // 品名取得中は品名セレクトを無効化
  $itemNameSelect.prop('disabled', true);

  $.ajax({
    url: '/quotation_order/item_name_list',
    type: 'post',
    data: { steel_pipe_type: steelPipeType },
    success: function(json) {
      var options = '<option value="">選択してください</option>';
      json.item_names.forEach(function(name) {
        options += '<option value="' + name + '">' + name + '</option>';
      });
      $itemNameSelect.html(options);
    },
    error: function(xhr, status, e) {
      alert(status);
    },
    complete: function() {
      $itemNameSelect.prop('disabled', false);
    }
  });
});

// 品名・規格名選択時に寸法等の情報を取得
$(document).on('change', '.item-name-text-select', function() {
  var itemNameText = $(this).val();
  var steelPipeType = $('.category-select').val();

  if (!itemNameText) return;

  // 「寸法から選択」の場合、品名と寸法の表示位置を入れ替える
  if (itemNameText === '寸法から選択') {
    isSizeFullSearchMode = true;
    swapToSizeFullFirst();
    // 品名・規格名をリセットし、「寸法から選択」を選択肢から除外
    var $itemNameSelect = $('.item-name-text-select');
    if ($itemNameSelect.data('select2')) {
      $itemNameSelect.select2('destroy');
    }
    $itemNameSelect.html('<option value=""></option>');
    $itemNameSelect.select2({
      placeholder: '寸法を選択してください',
      dropdownParent: $('#select-item-modal')
    }).parent().find('.select2-container').width('100%');
    changeSearchStockButtonDisabled();
  } else if (!isSizeFullSearchMode) {
    // 「寸法から選択」ではない場合は元に戻す
    swapToItemNameFirst();
  }

  // 「寸法から選択」選択中に品名が選ばれた場合は長さを品名+寸法で再取得
  if (isSizeFullSearchMode && itemNameText !== '寸法から選択') {
    var sizeFullVal = $('.size-full-select').val();
    if (sizeFullVal) {
      fetchLengthByItemName(itemNameText, sizeFullVal);
    }
    changeSearchStockButtonDisabled();
    return;
  }

  $.ajax({
    url: '/stocks/steel_pipe',
    type: 'post',
    data: {
      item_name_text: itemNameText,
      steel_pipe_type: steelPipeType
    },
    success: function(json, status, xhr) {
      const contentType = xhr.getResponseHeader("content-type") || "";
      if (contentType.indexOf('html') > -1) {
        alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
        location.href = '/login';
      }
      if (contentType.indexOf('json') > -1) {
        $('#selected-steel-pipe-cuttable').val(json.steel_pipe_is_cuttable);
        setSteelPipeItem(json);
      }
      changeSearchStockButtonDisabled();
    },
    error: function(xhr, status, e) {
      alert(status);
    }
  });
});

//「寸法から選択」の場合、入力フォームの入れ替え
function swapToSizeFullFirst() {
  var $itemNameGroup = $('#item-name-form-group');
  var $sizeFullGroup = $('#size-full-form-group');
  if ($itemNameGroup.index() < $sizeFullGroup.index()) {
    $sizeFullGroup.insertBefore($itemNameGroup);
  }
}

// 「寸法から選択」以外の場合、入力フォームの入れ替えを元に戻す
function swapToItemNameFirst() {
  var $itemNameGroup = $('#item-name-form-group');
  var $sizeFullGroup = $('#size-full-form-group');
  if ($sizeFullGroup.index() < $itemNameGroup.index()) {
    $itemNameGroup.insertBefore($sizeFullGroup);
  }
}

// /stocks/steel_pipe からのレスポンスを各フォームにセット
function setSteelPipeItem(json) {
  $('.item-name').html(json.item_name);
  $('.item-name-hidden').val(json.item_name);
  // .size-full-selectはmm呼称を表示（サーバ応答のsize_fulls2を利用）
  // .size-full2-selectはA呼称を表示（サーバ応答のsize_fulls3を利用）
  $('.size-full-select').html(json.size_fulls2);
  $('.size-full2-select').html(json.size_fulls3 || '');
  sizeFullMap = json.size_full_map || {};
  $('.length-select').html([]);
  $('.item-name-select').html([]);
  // 寸法Select2を安全に再初期化
  reinitSelect2($('.size-full-select'), {placeholder: '（mm呼称）', dropdownParent: $('#select-item-modal')});
  $('select.select2.size-full-select')
    .val(null).trigger('change.select2');
  reinitSelect2($('.size-full2-select'), {placeholder: '（A呼称）', dropdownParent: $('#select-item-modal')});
  $('select.select2.size-full2-select')
    .val(null).trigger('change.select2');
  if ($('#selected-steel-pipe-cuttable').val() == 'true'){
    $('.length-select-form').hide()
    $('.length-text-form').show()
    $('.length-text').val(null)
    $('.enter_length_text').html('長さ入力可')
  }else{
    $('.length-select-form').show()
    $('.length-text-form').hide()
    $('.enter_length_text').html(null)
    reinitSelect2($('.length-select'), {placeholder: '寸法を選択してください', dropdownParent: $('#select-item-modal')});
  }
  $('#selected-steel-pipe-type').val(json.steel_pipe_type)
  defineSizefullSelect();
  window.removeErrorMessage($('.length-text'))

  // 「寸法から選択」の場合、寸法選択時に品名・規格名を絞り込むイベントを登録
  if (json.is_size_full_search) {
    defineSizeFullItemNameFilter();
  }
}
window.setSteelPipeItem = setSteelPipeItem;

// 「寸法から選択」で品名が選ばれた後に、品名+寸法で長さを再取得する
function fetchLengthByItemName(steelPipeName, sizeFullText) {
  fetchLengthForSizeFull(sizeFullText, { item_name_text: '寸法から選択', steel_pipe_name: steelPipeName });
}

// 寸法から長さを取得する共通関数
function fetchLengthForSizeFull(sizeFullText, opts) {
  opts = opts || {};
  var data = {
    item_name_text: opts.item_name_text || $('.item-name-hidden').val(),
    size_full_text: (sizeFullText || '').toString(),
    steel_pipe_type: $('#selected-steel-pipe-type').val(),
    steel_pipe_name: opts.steel_pipe_name || ''
  };

  $.ajax({
    url: '/stocks/steel_pipe_length',
    type: 'post',
    data: data,
    success: function(json, status, xhr) {
      var contentType = xhr.getResponseHeader("content-type") || "";
      if (contentType.indexOf('html') > -1) {
        alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
        location.href = '/login';
      }
      if (contentType.indexOf('json') > -1) {
        if ($('.item-name-hidden').val() == '寸法から選択'){
          if (json.is_cuttable){
            $('.length-select-form').hide()
            $('.length-text-form').show()
            $('.length-text').val(null)
            window.removeErrorMessage($('.length-text'))
            $('.enter_length_text').html('長さ入力可')
          }else{
            $('.length-select-form').show()
            $('.length-text-form').hide()
            $('.enter_length_text').html(null)
            reinitSelect2($('.length-select'), {placeholder: '選択してください', dropdownParent: $('#select-item-modal')});
          }
        }
        if (json.is_cuttable){
          var length_text_select = $('.length-text-select')
          length_text_select.empty()
          length_text_select.append(json.lengths)
          if (json.single_flg) {
            $('.length-text').val(json.length)
            $('.length-text').trigger('change.with-request')
          }else {
            $('.length-text').val(null)
            window.removeErrorMessage($('.length-text'))
          }
        }else{
          $('.length-select').html(json.lengths);
          if (json.single_flg) {
            reinitSelect2($('.length-select'), {placeholder: '選択してください', dropdownParent: $('#select-item-modal')});
            $('select.select2.length-select').val(json.length).trigger('change.select2');
            reinitSelect2($('.item-name-select'), {placeholder: '長さを選択してください', dropdownParent: $('#select-item-modal')});
            $('.length-select').trigger('change.with-request')
          }else {
            reinitSelect2($('.length-select'), {placeholder: '選択してください', dropdownParent: $('#select-item-modal')});
            $('select.select2.length-select').val(null).trigger('change.select2');
            reinitSelect2($('.item-name-select'), {placeholder: '長さを選択してください', dropdownParent: $('#select-item-modal')});
          }
        }
      }
      if($('#selected_text_length_val').length) {
        $('.length-text').val($('#selected_text_length_val').val())
        $('#selected_text_length_val').remove();
      }
      if($('#selected_length_val').length) {
        $('select.select2.length-select').val($('#selected_length_val').val()).trigger('change.select2');
        $('#selected_length_val').remove();
      }
      $('#selected-steel-pipe-max-length').val(json.steel_pipe_max_length)


      changeSearchStockButtonDisabled()
    },
    error: function(xhr, status, e) {
      alert(status);
    }
  });
}

// 寸法のセレクトボックスを変更した際に長さを取得する
function defineSizefullSelect() {
  $('.size-full-select').off('change.with-request');
  $('.size-full-select').on('change.with-request', function(event){

    var steelPipeName = '';
    if (isSizeFullSearchMode) {
      var selectedItemName = $('.item-name-text-select').val();
      if (selectedItemName && selectedItemName !== '寸法から選択') {
        steelPipeName = selectedItemName;
      }
    }

    fetchLengthForSizeFull($(this).val(), { item_name_text: $('.item-name-hidden').val(), steel_pipe_name: steelPipeName });
  });
}

// mm呼称選択時にA呼称を連動させる
$(document).on('change', '.size-full-select', function() {
  var selectedSizeFull = $(this).val();
  var $sizeFull2 = $('.size-full2-select');
  if (!selectedSizeFull || !sizeFullMap[selectedSizeFull]) {
    $sizeFull2.val(null).trigger('change.select2');
    return;
  }
  var matchedValues = sizeFullMap[selectedSizeFull];
  if (matchedValues.length > 0) {
    $sizeFull2.val(matchedValues[0]).trigger('change.select2');
  } else {
    $sizeFull2.val(null).trigger('change.select2');
  }
  // mm呼称のみ選択されA呼称が存在しない場合、A呼称を空欄に
  if (matchedValues.length === 0) {
    $sizeFull2.val(null).trigger('change.select2');
  }
});

// A呼称選択時にmm呼称を連動させる
$(document).on('change', '.size-full2-select', function() {
  var selectedSizeFull2 = $(this).val();
  var found = false;
  if (!selectedSizeFull2) return;
  for (var sizeFull1 in sizeFullMap) {
    if (sizeFullMap[sizeFull1].indexOf(selectedSizeFull2) !== -1) {
      var $sizeFull1 = $('.size-full-select');
      if ($sizeFull1.val() !== sizeFull1) {
        $sizeFull1.val(sizeFull1).trigger('change.select2');
        $sizeFull1.trigger('change.with-request');
        $sizeFull1.trigger('change.filter-item-name');
      } else {
        $sizeFull1.trigger('change.filter-item-name');
      }
      found = true;
      break;
    }
  }
  // A呼称のみ選択されmm呼称が存在しない場合、mm呼称を空欄に
  // A呼称を使って長さを取得する
  if (!found) {
    $('.size-full-select').val(null).trigger('change.select2');
    var selectedA = selectedSizeFull2;
    // A呼称のみで品名・規格名の選択肢をサーバから取得する
    if ($('.item-name-hidden').val() === '寸法から選択' || isSizeFullSearchMode) {
      var $itemNameSelect = $('.item-name-text-select');
      var steelPipeType = $('#selected-steel-pipe-type').val();
      if ($itemNameSelect.data('select2')) {
        $itemNameSelect.select2('destroy');
      }
      $itemNameSelect.html('<option value="">選択してください</option>');
      fetchAndPopulateItemNames(selectedA, steelPipeType, $itemNameSelect);
    }

    fetchLengthForSizeFull(selectedA, { item_name_text: $('.item-name-hidden').val(), steel_pipe_name: '' });
  }
});

//「寸法から選択」時に寸法選択で品名・規格名を絞り込むイベントを登録
function defineSizeFullItemNameFilter() {
  $('.size-full-select').off('change.filter-item-name');
  $('.size-full-select').on('change.filter-item-name', function() {
    var sizeFullText = $(this).val();
    var steelPipeType = $('#selected-steel-pipe-type').val();
    var $itemNameSelect = $('.item-name-text-select');

    if (!sizeFullText) {
      if ($itemNameSelect.data('select2')) {
        $itemNameSelect.select2('destroy');
      }
      $itemNameSelect.html('<option value=""></option>');
      $itemNameSelect.select2({
        placeholder: '寸法を選択してください',
        dropdownParent: $('#select-item-modal')
      }).parent().find('.select2-container').width('100%');
      return;
    }

    fetchAndPopulateItemNames(sizeFullText, steelPipeType, $itemNameSelect);
  });
}

// 品名/規格名選択肢の共通関数
function fetchAndPopulateItemNames(sizeFullText, steelPipeType, $itemNameSelect) {
  if ($itemNameSelect.data('select2')) {
    $itemNameSelect.select2('destroy');
  }
  $itemNameSelect.html('<option value="">選択してください</option>');
  $.ajax({
    url: '/stocks/steel_pipe_name',
    type: 'post',
    data: {
      size_full_text: sizeFullText,
      steel_pipe_type: steelPipeType
    },
    success: function(json, status, xhr) {
      var contentType = xhr.getResponseHeader("content-type") || "";
      if (contentType.indexOf('html') > -1) {
        alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
        location.href = '/login';
      }
      if (contentType.indexOf('json') > -1) {
        $itemNameSelect.html('<option value="">選択してください</option>' + (json.steel_pipe_names || ''));
        $itemNameSelect.select2({
          placeholder: '選択してください',
          dropdownParent: $('#select-item-modal')
        }).parent().find('.select2-container').width('100%');
        if (json.single_flg) {
          $itemNameSelect.val(json.steel_pipe_name).trigger('change.select2');
        } else {
          $itemNameSelect.val('').trigger('change.select2');
        }
      }
      changeSearchStockButtonDisabled();
    },
    error: function(xhr, status, e) {
      alert(status);
    }
  });
}

// 商品選択のフォームに必須情報が入力されているかのチェック
function stockSearchErrorMessage(){
  errors = []

  $('.item-name-hidden').val() ? '' : errors.push('商品名を入力してください');
  ($('.size-full-select').val() || $('.size-full2-select').val()) ? '' : errors.push('寸法を入力してください');
  getLengthValue() ? '' : errors.push('長さを入力してください');
  if ($('.length-text-form').css('display') != 'none'){
    window.overCharaLength(getLengthValue() || '', 6) ? errors.push('長さ:入力した文字が長すぎます。') : ''
    window.includeUnusableCharacters(getLengthValue()) ? errors.push('長さ:入力した文字は使用できません。') : ''
    var lengthVal = $('.length-text').val()
    if (!window.isNumeric(lengthVal)) {
      var lastChar = (lengthVal || '').slice(-1)
      if (lastChar !== '.') {
        errors.push('長さ:数値を入力してください。')
      }
    }
    $('.length-text').val() > Number($('#selected-steel-pipe-max-length').val()) ? errors.push('長さ:ご指定いただけません。') : ''
  }
  // 員数チェック（createTagで入力制限済みのため、ボタン無効化制御用）
  var pipeNumVal = $('#pipe_num').val();
  if (!pipeNumVal) {
    errors.push('員数を入力してください');
  } else if (!/^\d+$/.test(pipeNumVal)) {
    errors.push('員数:数値を入力してください。');
  } else {
    var pipeNum = parseInt(pipeNumVal, 10);
    if (pipeNum < 1 || pipeNum > 9999) {
      errors.push('員数:1〜9999の範囲で入力してください。');
    }
  }
  // 「寸法から選択」時は品名・規格名の選択をチェック
  if ($('.item-name-hidden').val() === '寸法から選択') {
    var selectedItemName = $('.item-name-text-select').val();
    (!selectedItemName || selectedItemName === '寸法から選択') ? errors.push('品名・規格名を選択してください') : ''
  }
  return errors
}
window.stockSearchErrorMessage = stockSearchErrorMessage;

// 在庫検索ボタンの活性/非活性制御
function changeSearchStockButtonDisabled(){
  errors = stockSearchErrorMessage()

  if (errors.length > 0) {
    $('.add-quotation-detail').prop("disabled", true);
  }else{
    $('.add-quotation-detail').prop("disabled", false);
    window.changeAddQuotationDetailButtonDisabled();
  }
  // 商品決定ボタンの活性/非活性を制御
  changeConfirmItemButtonDisabled();
}
window.changeSearchStockButtonDisabled = changeSearchStockButtonDisabled;

// 商品決定ボタンの活性/非活性制御
function changeConfirmItemButtonDisabled(){
  var disabled = false;

  // カテゴリ
  if (!$('.category-select').val()) disabled = true;
  // 品名・規格名
  if (isSizeFullSearchMode) {
    var itemNameVal = $('.item-name-text-select').val();
    if (!itemNameVal || itemNameVal === '寸法から選択') disabled = true;
  } else {
    if (!$('.item-name-text-select').val()) disabled = true;
  }
  // 寸法
  if (!$('.size-full-select').val() && !$('.size-full2-select').val()) disabled = true;
  // 長さ
  if (!getLengthValue()) disabled = true;
  // 長さテキスト入力時の追加バリデーション
  if ($('.length-text-form').css('display') != 'none') {
    var lengthVal = $('.length-text').val();
    if (!window.isNumeric(lengthVal)) disabled = true;
    if (Number(lengthVal) > Number($('#selected-steel-pipe-max-length').val())) disabled = true;
  }
  // 員数
  var pipeNumVal = $('#pipe_num').val();
  if (!pipeNumVal || !/^\d+$/.test(pipeNumVal)) {
    disabled = true;
  } else {
    var pipeNum = parseInt(pipeNumVal, 10);
    if (pipeNum < 1 || pipeNum > 9999) disabled = true;
  }

  $('.confirm-item-btn').prop('disabled', disabled);
}

// 商品選択のフォームのクリアボタンを押下した際の処理
function itemSearchFealdClear(){
  $('.select-item-name-text').text('')
  $('.size-full-select').html([])
  $('.size-full2-select').html([])
  $('.length-select').html([])
  $('.length-text').val('')
  $('.enter_length_text').html(null)
  window.removeErrorMessage($('.length-text'))
  $('#pipe_num').val('1').trigger('change')
  // 品名・規格名ドロップダウンをリセット
  if ($('.item-name-text-select').data('select2')) {
    $('.item-name-text-select').select2('destroy');
  }
  $('.item-name-text-select').html('<option value="">選択してください</option>');
  // フォーム順序を元に戻す
  isSizeFullSearchMode = false;
  swapToItemNameFirst();
  // 寸法から品名絞り込みイベントを解除
  $('.size-full-select').off('change.filter-item-name');
  // カテゴリを初期値に戻し、品名の選択肢を再取得
  var $categorySelect = $('.category-select');
  var defaultValue = $categorySelect.find('option').first().val();
  $categorySelect.val(defaultValue).trigger('change');
}

// 長さのフォームが二種類あるので値を取得する関数を用意
function getLengthValue(){
  var value = $('.search-length:visible').first().val()

  return value;
}
window.getLengthValue = getLengthValue;

// 明細追加のトリガー（カスタムイベントで本体側に通知）
function triggerAddQuotationDetail(){
  errors = stockSearchErrorMessage()

  if (errors.length > 0) {
    alert(errors.join("\n"))
    return false
  }

  var data = {
    item_name: $('.item-name-hidden').val(),
    size_full: $('.size-full-select').val() || $('.size-full2-select').val(),
    length: getLengthValue(),
    pipe_num: $('#pipe_num').val(),
    steel_pipe_name: ($('.item-name-hidden').val() === '寸法から選択') ? $('.item-name-text-select').val() : '',
    steel_pipe_type: $('#selected-steel-pipe-type').val(),
    row_num: $('.quotation_detail_table_item').length + 1,
    with_milsheet: $('#with_milsheet').prop('checked')
  }

  $(document).trigger('quotationOrder:itemSelected', [data])
}

